import React from 'react'
import classNames from 'classnames'

const Overlay = ({ className, children, style }) => {
  return (
    <div
      className={classNames('p-fixed l-0 r-0 b-0 t-0 flex flex-center flex-middle', className)}
      style={{
        backgroundColor: 'rgba(0, 0, 0,0.2)',
        ...style
      }}
    >
      {children}

    </div>
  )
}

export default Overlay
